import { usePerms } from 'contexts/PermsContext';
import { useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import {
  useDeleteGroupMutation,
  useGetGroupsQuery,
} from 'services/devices/groups/groups.api';
import AddEditGroupModal from './features/AddEditGroupModal';
import DeleteGroupModal from './components/DeleteGroupModal';
import GroupSettingsModal from './features/GroupSettingsModal';
import Accordion from './components/Accordion';
import Table from './components/Table';
import { notifyErrorToast, notifySuccessToast } from 'utils/notifications/toast.utils';

export default function ConnectedDeviceGroups() {
  const { data: deviceGroups = [] } = useGetGroupsQuery();

  const [deleteGroup] = useDeleteGroupMutation();
  const perms = usePerms();

  // Modal state: -2 closed, -1 add, >=0 edit by group id.
  const [modalOpen, setModalOpen] = useState(-2);
  const [toDelete, setToDelete] = useState(null);
  const [settingsGroupId, setSettingsGroupId] = useState(null);

  const onAddGroup = () => setModalOpen(-1);

  const onEditGroup = (id) => setModalOpen(id);

  const onDeleteGroup = (group) => setToDelete(group);

  const onOpenGroupSettings = (groupId) => setSettingsGroupId(groupId);
  const onCloseGroupSettings = () => setSettingsGroupId(null);

  const resolveDelete = async (success) => {
    try {
      if (success && toDelete) {
        await deleteGroup(toDelete.id).unwrap();
        notifySuccessToast('Device group', { isAddOperation: false, isDeleteOperation: true });
      }
    } catch (error) {
      console.error('Failed to delete group.');
      notifyErrorToast('Device group', { isAddOperation: false, isDeleteOperation: true });
    }

    setToDelete(null);
  };



  const hasDeletePermission = perms.testPermission([8, 9, 10, 11, 12, 13], ['DeleteDeviceGroups']);

  const hasCreateEditPermission = perms.testPermission(
    [8, 9, 10, 11, 12, 13],
    ['Create-EditDeviceGroups'],
  );

  const settingsGroup = deviceGroups?.find((group) => group.id === settingsGroupId);

  return (
    <Container fluid className="d-flex flex-column h-100 min-h-0">
      <div className="flex-grow-1 min-h-0 overflow-auto">
        <Table
          hasCreateEditPermission={hasCreateEditPermission}
          hasDeletePermission={hasDeletePermission}
          onEditGroup={onEditGroup}
          onDeleteGroup={onDeleteGroup}
          onOpenGroupSettings={onOpenGroupSettings}
        />

        <Accordion
          hasCreateEditPermission={hasCreateEditPermission}
          hasDeletePermission={hasDeletePermission}
          onEditGroup={onEditGroup}
          onDeleteGroup={onDeleteGroup}
          onOpenGroupSettings={onOpenGroupSettings}
        />
      </div>

      {hasCreateEditPermission && (
        <div className="flex-shrink-0 d-flex justify-content-center justify-content-lg-start w-100 pt-3">
          <Button className="w-100 w-md-3xs py-3 py-md-4" variant="primary" onClick={onAddGroup}>
            New Device Group
          </Button>
        </div>
      )}

      <AddEditGroupModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
      <DeleteGroupModal toDelete={toDelete} resolveDelete={resolveDelete} />
      <GroupSettingsModal
        show={!!settingsGroup}
        onClose={onCloseGroupSettings}
        group={settingsGroup}
      />
    </Container>
  );
}
